import { render } from "./AdminSidebar.vue?vue&type=template&id=f073acf8&scoped=true"
import script from "./AdminSidebar.vue?vue&type=script&lang=js"
export * from "./AdminSidebar.vue?vue&type=script&lang=js"

import "./AdminSidebar.vue?vue&type=style&index=0&id=f073acf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f073acf8"]])

export default __exports__